import { render, staticRenderFns } from "./CreateSkillDialog.vue?vue&type=template&id=6809ea9a&scoped=true"
import script from "./CreateSkillDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreateSkillDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateSkillDialog.vue?vue&type=style&index=0&id=6809ea9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6809ea9a",
  null
  
)

export default component.exports